export enum View {
  NotesList = 'NotesList',
  AddNote = 'AddNote',
  EditNote = 'EditNote',
}

export default {};
